module.exports = __webpack_public_path__ + "img/food-39.d6d70ac0.jpg";